import { createContext, useContext, useState, useEffect } from 'react';

// Contexte d'authentification
const AuthContext = createContext();

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(localStorage.getItem('token'));

    // Charger l'utilisateur au démarrage
    useEffect(() => {
        const savedUser = localStorage.getItem('user');
        if (savedUser && token) {
            setUser(JSON.parse(savedUser));
        }
    }, [token]);

    // Connexion — sauvegarder le token et l'utilisateur
    const loginUser = (userData, accessToken) => {
        setUser(userData);
        setToken(accessToken);
        localStorage.setItem('token', accessToken);
        localStorage.setItem('user', JSON.stringify(userData));
    };

    // Déconnexion — tout vider
    const logout = () => {
        setUser(null);
        setToken(null);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
    };

    // Propriétés d'authentification
    const isLoggedIn = !!token && !!user;
    const isAdmin = user?.role === 'admin';

    return (
        <AuthContext.Provider value={{ user, token, isLoggedIn, isAdmin, loginUser, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

// Hook pour utiliser le contexte
export const useAuth = () => useContext(AuthContext);